import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@acb_devel/design-system';
import { Heading } from '@acb_devel/design-system';
import { Button } from '@acb_devel/design-system';
import type { Registration } from '@services/registrations';
import { Checkbox } from '@acb_devel/design-system';

import styles from './SelectAreasModal.module.scss';

export function SelectAreasModal({
  isOpen,
  closeModal,
  registration,
  setRegistration,
  onSubmitted,
}: {
  isOpen: boolean;
  closeModal: () => void;
  registration: Registration | null;
  setRegistration: (registration: Registration) => void;
  onSubmitted: (registration: Registration | null) => void;
}) {
  return (
    <Modal isOpen={isOpen} onClose={closeModal} size="md">
      <ModalHeader closeModal={closeModal}>Antes de finalizar...</ModalHeader>
      <ModalBody>
        <div className={styles.modal__content}>
          <div className={styles.modal__eventInfo}>
            <Heading as="h5" variant="subhead">
              <strong>¿A qué área/s lo quieres asignar?</strong>
            </Heading>
          </div>
          <div className={styles.modal__areasList}>
            {registration?.event.eventAreas?.map((area) => (
              <Checkbox
                key={area.id}
                id={`area-${area.id}`}
                label={area.name}
                checked={registration.assignedEventAreas.some(
                  (assignedArea) => assignedArea.id === area.id
                )}
                onCheckedChange={(checked) => {
                  if (checked) {
                    setRegistration({
                      ...registration,
                      assignedEventAreas: [
                        ...registration.assignedEventAreas,
                        area,
                      ],
                    });
                  } else {
                    setRegistration({
                      ...registration,
                      assignedEventAreas:
                        registration.assignedEventAreas.filter(
                          (assignedArea) => assignedArea.id !== area.id
                        ),
                    });
                  }
                }}
              />
            ))}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="solid"
          color="primary"
          onClick={() => onSubmitted(registration)}
        >
          Asignar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
